import { Injectable } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiEndpoints, ApiErrorCode, ApiService, httpErrorToApiError } from '@nano/core/api';
import { ErrorService } from '@nano/core/error';
import { StartMessageThreadRequest, StartMessageThreadResponse } from './start-message-thread';

@Injectable({ providedIn: 'root' })
export class StartMessageThredService {
  constructor(
    private apiService: ApiService,
    private errorService: ErrorService
  ) {}

  private mapHttpErrorToApiError(error: HttpErrorResponse) {
    return httpErrorToApiError(error);
  }

  startMessageThread(request: StartMessageThreadRequest): Observable<string> {
    return this.apiService.post<StartMessageThreadResponse>(ApiEndpoints.messageThreads(), request).pipe(
      take(1),
      map((response: StartMessageThreadResponse) => response.id),
      catchError((error: unknown) => {
        const apiError = this.mapHttpErrorToApiError(error as HttpErrorResponse);
        if (apiError.code === (ApiErrorCode.communicationThrottlingException as string)) {
          this.errorService.showErrorModal(apiError);
          return EMPTY;
        }
        return throwError(() => error);
      })
    );
  }
}
